import { createFileRoute } from '@tanstack/react-router'
import { ProfilePanel } from '@/components/me/profile-panel'

export const Route = createFileRoute('/me')({
  component: ProfilePanel,
})
